import { useMatchMedia } from '@hst-horizon/horizon-ui';

const useMobileViewMatchMedia = () => {
    return useMatchMedia('(max-width: 767px)');
};

export default useMobileViewMatchMedia;
